<template>
  <div class="box" v-if="state.uid" ref="scrollRef">
    <van-pull-refresh
      v-model="state.refreshLoading"
      @refresh="onRefresh"
      style="min-height: 100%"
    >
      <!-- 热门社区 -->
      <div class="hot-association" v-if="state.hotgameList.length">
        <p>
          <img src="../../assets/gameCommunity/association_hot.png" alt="" />

          <span>热门社区 </span>
        </p>
        <ul class="hot-list">
          <li
            v-for="(item, index) in state.hotgameList"
            @touchmove.stop
            @click="goComunity(item.id)"
          >
            <img :src="item.pic1" alt="" />
            <p>{{ item.gamename }}</p>
          </li>
          <i class="mask"></i>
        </ul>
      </div>

      <!-- 社区活动 -->
      <div class="activity-association" v-if="state.activityList.length">
        <span>社区活动</span>
        <ul>
          <li
            class="activiy-list"
            v-for="(item, index) in state.activityList"
            @click="goActivity(item)"
          >
            <img :src="item.slide_pic" alt="" />
          </li>
        </ul>
      </div>

      <!-- 推荐帖子 -->
      <div class="recommend-post" v-if="state.commentList.length">
        <span>推荐帖子</span>
        <van-list
          v-model:loading="state.conmmetLoading"
          :finished="state.commentFinished"
          :finished-text="state.finishedText"
          @load="onLoad"
        >
          <van-cell v-for="item in state.commentList" :key="item + 'comment'">
            <template #value>
              <!-- 评论详情组件 -->
              <commentItem
                :data="item"
                :like="state.isLike"
                :deletePermission="state.deletePermission"
                @goCommentDetails="goCommentDetails"
                @likeThisComment="likeThisComment"
                @deleteComment="deleteComment"
              >
              </commentItem>
            </template>
          </van-cell>
        </van-list>
      </div>
    </van-pull-refresh>

    <div class="giveComment" @click="goCommentPublish">
      <img src="../../assets/game/yz_game_conment_inset.png" alt="" />
      <span>发表</span>
    </div>
    <div
      class="backToTop"
      :class="state.scrollTop > 800 ? 'show' : ''"
      @click="backToTop"
    >
      <img src="../../assets/game/ya_game_backToTop.png" alt="" />
    </div>
  </div>
  <div v-else>
    <div class="no-data">
      <img src="../../assets/chat/chat_noGroup.png" alt="" />
      <p>登录后查看社区～</p>
    </div>
  </div>
</template>
<script setup>
import {
  onActivated,
  onMounted,
  reactive,
  ref,
  nextTick,
  onDeactivated,
} from "vue";
import { useRouter } from "vue-router";
import commentItem from "./gameCommunity/components/commentItem.vue";
import { getAssociationInfo } from "@/api/yzCommunity";
import { useStore } from "vuex";
import { debounce } from "@/utils/emojiToCode";
import { Local } from "@/utils/storage";
import { getQueryString } from "@/utils/location";
import { setToken } from "@/utils/auth.js";

import {
  handleLike,
  handleComments,
  // goActivity,
  handleDelete,
} from "./handleCommunity.js";
import { Toast } from "vant";

const store = useStore();
const router = useRouter();
const state = reactive({
  refreshLoading: false,
  conmmetLoading: false,
  commentFinished: true,
  activityList: [],
  commentList: [],
  hotgameList: [],
  isLike: [],
  deletePermission: false,
  uid: getQueryString("uid"),
  username: getQueryString("username"),
  mobile: getQueryString("mobile"),
  scrollTop: 0,
  finishedText: "没有更多了～",
});

const scrollRef = ref(null);

onMounted(async () => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }
  state.uid = Number(getQueryString("uid"));
  state.username = getQueryString("username");
  state.mobile = getQueryString("mobile");
  Local.set("uid", state.uid);
  // console.log("推荐社区页激活-------onActivated", state.uid);
  if (!state.uid) return;
  await store.dispatch("getInfo");
  nextTick(() => {
    if (state.scrollTop) {
      scrollRef.value.scrollTop = state.scrollTop;
    }

    scrollRef.value &&
      scrollRef.value.addEventListener("scroll", debounceHandleScroll);
  });
  await onLoad();
});

onActivated(() => {
  state.uid = Number(getQueryString("uid"));
  nextTick(() => {
    if (state.scrollTop) {
      scrollRef.value.scrollTop = state.scrollTop;
    }

    scrollRef.value &&
      scrollRef.value.addEventListener("scroll", debounceHandleScroll);
  });
});

onDeactivated(() => {
  scrollRef.value &&
    scrollRef.value.removeEventListener("scroll", debounceHandleScroll);
});

const handleScroll = () => {
  state.scrollTop = scrollRef.value.scrollTop;
};
const debounceHandleScroll = debounce(handleScroll, 100);

const onRefresh = async () => {
  state.refreshLoading = true;
  state.commentFinished = true;
  state.conmmetLoading = false;
  state.commentList = [];
  state.isLike = [];
  state.finishedText = " ";
  pagecode = 1;
  await getAssociation();
};

const onLoad = async () => {
  state.conmmetLoading = true;
  await getAssociation();
};

var pagecode = 1;
const getAssociation = async () => {
  try {
    let res = await getAssociationInfo({
      pagecode: pagecode,
      ctype: "",
      uid: state.uid,
    });
    if (res.data.code == 1) {
      state.refreshLoading = false;
      state.activityList = res.data.data.active;
      state.hotgameList = res.data.data.hotgame;
      state.deletePermission = res.data.data.adminIds.includes(state.uid);
      // 解构评论列表
      const { commentList, likeArr } = handleComments(
        res.data.data.comments.lists
      );

      state.commentList = state.commentList.concat(commentList);
      state.isLike = state.isLike.concat(likeArr);

      if (pagecode >= res.data.data.comments.total_page) {
        state.commentFinished = true;
        state.finishedText = "没有更多了～";
      } else {
        state.commentFinished = false;
        state.conmmetLoading = false;
        pagecode++;
      }
    } else {
      state.commentFinished = true;
      Toast(res.data.msg);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

// 跳转至游戏社区
const goComunity = (gid) => {
  // router.push({
  //   path: "/GameCommunity",
  //   query: {
  //     gid: gid,
  //     username: state.username,
  //     uid: state.uid,
  //     mobile: state.mobile,
  //   },
  // });
  // window.JsBridge.skipImmersionWebActivity(
  //   `${"GameCommunity?gid=" +
  //     gid +
  //     "&username=" +
  //     state.username +
  //     "&uid=" +
  //     state.uid +
  //     "&mobile=" +
  //     state.mobile}˝`
  // );
  window.JsBridge.skipShequActivity(String(gid));
};
// 跳转对应评论
const goCommentDetails = (id, post_id) => {
  console.log("跳转至评论详情---", id, post_id);
  // router.push({
  //   path: "/game/gameCommunity/commentdetails",
  //   query: {
  //     comments_id: item,
  //     gid: post_id,
  //     deletePermission: state.deletePermission,
  //     username: state.username,
  //     uid: state.uid,
  //     mobile: state.mobile,
  //   },
  // });
  window.JsBridge.skipImmersionWebActivity(
    `${"game/gameCommunity/commentdetails?gid=" +
      post_id +
      "&comments_id=" +
      id +
      "&deletePermission=" +
      state.deletePermission +
      "&username=" +
      state.username +
      "&uid=" +
      state.uid +
      "&mobile=" +
      state.mobile}`
  );
};

const likeThisComment = async (id) => {
  const { arr, likeArr } = await handleLike(
    id,
    state.commentList,
    state.isLike
  );
  state.commentList = arr;
  state.isLike = likeArr;
};

//隐藏帖子
const deleteComment = async (id) => {
  if (await handleDelete(id)) {
    onRefresh();
  }
};

const backToTop = () => {
  scrollRef.value.scrollTop = 0;
};

const goCommentPublish = () => {
  if (Local.get("commentGame")) {
    Local.remove("commentGame");
  }
  Local.set("commentGame", JSON.stringify(state.hotgameList));

  // router.push({
  //   path: "/game/gameCommunity/commentpublish",
  //   query: {
  //     gid: "",
  //     gamename: "",
  //     username: state.username,
  //     uid: state.uid,
  //     mobile: state.mobile,
  //   },
  // });
  window.JsBridge.skipImmersionWebActivity(
    `${"game/gameCommunity/commentpublish?username" +
      state.username +
      "&uid=" +
      state.uid +
      "&mobile=" +
      state.mobile}`
  );
};

const goActivity = (data) => {
  window.JsBridge.skipCommunitybanner(data.jump_url, data.slide_name);
};
</script>

<style src="../../styles/removeVantcell.css" scoped></style>
<style scoped>
.box {
  height: 100vh;
  width: 100%;
  padding: 0 32px;
  overflow: auto;
  background-color: #f7f7fa;
}
.hot-association,
.activity-association,
.recommend-post {
  margin-bottom: 32px;
  font-size: 28px;
  color: #555555;
  position: relative;
  font-weight: 400;
}
.hot-association img {
  width: 32px;
  height: 32px;
  margin-right: 8px;
  vertical-align: text-top;
}

/* 社区列表 */
.hot-list {
  margin-top: 20px;
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  padding-right: 50px;
}
.hot-list::-webkit-scrollbar {
  display: none; /* 对于WebKit浏览器（如Chrome、Safari等），隐藏滚动条 */
}
.hot-list li {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
}
.hot-list li img {
  height: 100px;
  width: 100px;
  border-radius: 20px;
  overflow: auto;
  margin-bottom: 6px;
}
.hot-list li p {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 20px;
  text-align: center;
}
.hot-list .mask {
  width: 118px;
  height: 144px;
  background: linear-gradient(90deg, rgba(247, 247, 250, 0) 0%, #fff 75%);
  position: absolute;
  right: -32px;
  bottom: 0;
}
/* 社区活动 */
.activiy-list {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.activiy-list img {
  width: 332px;
  height: 176px;
  border-radius: 20px;
}
.activity-association ul {
  display: flex;
  justify-content: space-between;
}

/* 推荐帖子 */

.recommend-post {
  height: 100%;
  /* overflow: auto; */
}
.recommend-post .van-list {
  padding-top: 20px;
}

:deep(.van-cell) {
  margin-bottom: 20px;
  border-radius: 20px;
}
.no-data {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.no-data img {
  width: 400px;
  height: 400px;
}
.no-data p {
  font-size: 28px;
  color: #999999;
  position: absolute;
  bottom: 20px;
}
.backToTop {
  position: fixed;
  right: -100px;
  bottom: 100px;
  opacity: 0.3;
  transition: right 0.5s ease-in-out;
}

.backToTop img {
  width: 100px;
  height: 100px;
}

.backToTop.show {
  opacity: 1;
  right: 40px;
}

.giveComment {
  width: 100px;
  height: 100px;
  border-radius: 100px;
  position: fixed;
  right: 40px;
  bottom: 250px;
  background: linear-gradient(135deg, #00d9c5 0%, #00d9c5 100%);
  border: 6px solid #00d9c5;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
  font-size: 20px;
}
.giveComment img {
  width: 40px;
  height: 40px;
}
</style>
